@if (event) {
  <h1 class="shoutout-form__header">
    {{ event.name }} ({{ event.clientName }})
  </h1>
}
<div class="shoutout-form__container">
  <mat-card appearance="outlined">
    <mat-card-content>
      <form
        class="shoutout-form"
        [formGroup]="shoutoutForm"
        #shoutoutFormElement="ngForm"
      >
        @if (event && event.products && event.products.length > 0) {
          <mat-form-field class="shoutout-form__input" appearance="fill">
            <mat-label for="productId">Select pricing option</mat-label>
            <mat-select
              formControlName="productId"
              (selectionChange)="onProductChange($event.value)"
            >
              @for (product of event.products; track product.id) {
                <mat-option [value]="product.id"
                  >{{ product.name }} - ${{
                    product.amount.toFixed(2)
                  }}</mat-option
                >
              }
            </mat-select>
            <div>
              <mat-error>Please select a pricing option.</mat-error>
            </div>
          </mat-form-field>
        }
        @if (event && event.sessions.length > 0) {
          <mat-form-field class="shoutout-form__input" appearance="fill">
            <mat-label for="sessionId">Select you gymnast session</mat-label>
            <mat-select formControlName="sessionId">
              @for (session of event.sessions; track session.id) {
                <mat-option [value]="session.id">{{ session.name }}</mat-option>
              }
            </mat-select>
            <div>
              <mat-error>Please doublecheck your gymnast session.</mat-error>
            </div>
          </mat-form-field>
        }
        <mat-form-field class="shoutout-form__input" appearance="fill">
          <mat-label for="to">To</mat-label>
          <input matInput formControlName="to" />
          @if ((to?.dirty || to?.touched) && to?.errors?.["required"]) {
            <mat-error>To is required.</mat-error>
          }
          @if ((to?.dirty || to?.touched) && to?.errors?.["required"]) {
            <div>To is required.</div>
          }
          @if ((to?.dirty || to?.touched) && to?.errors?.["minlength"]) {
            <mat-error
              >Minimum number of characters is
              {{ to?.errors?.["minlength"]?.["requiredLength"] }}.</mat-error
            >
          }
          @if ((to?.dirty || to?.touched) && to?.errors?.["maxlength"]) {
            <mat-error
              >Maximum number of characters is
              {{ to?.errors?.["maxlength"]?.["requiredLength"] }}.</mat-error
            >
          }
        </mat-form-field>
        <mat-form-field class="shoutout-form__input" appearance="fill">
          <mat-label for="team">Team</mat-label>
          <input matInput formControlName="team" />
          @if ((team?.dirty || team?.touched) && team?.errors?.["required"]) {
            <mat-error>To is required.</mat-error>
          }
          @if ((team?.dirty || team?.touched) && team?.errors?.["required"]) {
            <div>To is required.</div>
          }
          @if ((team?.dirty || team?.touched) && team?.errors?.["minlength"]) {
            <mat-error
              >Minimum number of characters is
              {{ team?.errors?.["minlength"]?.["requiredLength"] }}.</mat-error
            >
          }
          @if ((team?.dirty || team?.touched) && team?.errors?.["maxlength"]) {
            <mat-error
              >Maximum number of characters is
              {{ team?.errors?.["maxlength"]?.["requiredLength"] }}.</mat-error
            >
          }
        </mat-form-field>
        <mat-form-field class="shoutout-form__input" appearance="fill">
          <mat-label for="from">From</mat-label>
          <input matInput formControlName="from" />
          @if ((from?.dirty || from?.touched) && from?.errors?.["required"]) {
            <mat-error>From is required.</mat-error>
          }
          @if ((from?.dirty || from?.touched) && from?.errors?.["minlength"]) {
            <mat-error
              >Minimum number of characters is
              {{ from?.errors?.["minlength"]?.["requiredLength"] }}.</mat-error
            >
          }
          @if ((from?.dirty || from?.touched) && from?.errors?.["maxlength"]) {
            <mat-error
              >Maximum number of characters is
              {{ from?.errors?.["maxlength"]?.["requiredLength"] }}.</mat-error
            >
          }
        </mat-form-field>
        <mat-form-field class="shoutout-form__input" appearance="fill">
          <mat-label for="message">Message</mat-label>
          <textarea
            matInput
            cdkTextareaAutosize
            formControlName="message"
          ></textarea>
          @if (
            (message?.dirty || message?.touched) &&
            message?.errors?.["required"]
          ) {
            <mat-error>Message is required.</mat-error>
          }
          @if (
            (message?.dirty || message?.touched) &&
            message?.errors?.["minlength"]
          ) {
            <mat-error
              >Minimum number of characters is
              {{
                message?.errors?.["minlength"]?.["requiredLength"]
              }}.</mat-error
            >
          }
          @if (
            (message?.dirty || message?.touched) &&
            message?.errors?.["maxlength"]
          ) {
            <mat-error
              >Maximum number of characters is
              {{
                message?.errors?.["maxlength"]?.["requiredLength"]
              }}.</mat-error
            >
          }
        </mat-form-field>
        @if (!isKioskMode()) {
          <div id="stripe-payment-element">
            <mat-spinner class="stripe-spinner"></mat-spinner>
          </div>
          @if (
            (stripeError || shoutoutForm.invalid) &&
            shoutoutFormElement.submitted
          ) {
            <mat-error>
              <strong>There is something wrong with your message</strong>
              @if (stripeError) {
                <div>
                  {{ stripeError.message }}
                </div>
              }
            </mat-error>
          }
        } @else if (event && event.paymentType !== EventPaymentEnum.CASH_ONLY) {
          <div class="shoutout-form__pay_with_card">
            Scan the QR code only for mobile/digital payments.<br />For
            <b>cash or physical credit cards</b>, pay the cashier directly.
            <qrcode
              [qrdata]="shareLink()"
              [width]="100"
              [errorCorrectionLevel]="'M'"
            >
            </qrcode>
          </div>
        }
        <div>
          <button
            mat-flat-button
            color="primary"
            class="shoutout-form__submit"
            (click)="onSubmit()"
            [disabled]="
              shoutoutForm.invalid ||
              (!isKioskMode() &&
                (!stripePaymentFormComplete ||
                  !stripePaymentMethod ||
                  stripeProcessing))
            "
          >
            {{
              isKioskMode()
                ? "Send Shoutout"
                : "Purchase $" + selectedPrice().toFixed(2)
            }}
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
